import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CaseTemplatePageType, IGetCourt_Request, IGetCourt_Response, IReferralTracker_Response, ReferralHistoryOrderBy, ReferralHistoryResult } from './agency-home.model';
import { map, Observable } from 'rxjs';
import { normalizeServerString, removeDelimiters } from '../../core/utils/convertors';
import { DefendantInfoCreate } from '../../shared/models/models';

@Injectable({ providedIn: 'root' })

export class AgencyHomeApiService {

    private baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.api.url;
    }

    //#region Court
    public getCourtDates(requestPayload: IGetCourt_Request) {
        const url = `${this.baseUrl}WebServices/DefendantCourt.asmx/BindDSNCourtGrid`;
        return this.httpClient.post<string>(url, requestPayload).pipe(map((res) => {
            const list = <Array<IGetCourt_Response>>JSON.parse(res);
            return list
        }));
    }

    public getReferralTrackerList(pageNumber?: number | null, orderBy?: ReferralHistoryOrderBy | null, sortDir?: 'desc' | 'asc' | null, iSearch?: string | null, where?: string | null
    ) {
        const url = `${this.baseUrl}WebServices/ReferralHistory.asmx/BindReferralHistoryGrid`;
        return this.httpClient.post<string>(url, {
            pageNumber: pageNumber || 1,
            orderby: orderBy || '0',
            sortDir: sortDir || 'desc',
            iSearch: iSearch || '',
            where: where,
        }).pipe(map(wrapper =>
            (<unknown[][]>JSON.parse(wrapper)).map(
                parsed =>
                    <ReferralHistoryResult>{
                        referralDate: (parsed[1] as string),
                        referringOfficer: normalizeServerString(parsed[2] as string),
                        defendantName: normalizeServerString(parsed[3] as string),
                        incident: normalizeServerString(parsed[4] as string),
                        charge: normalizeServerString(parsed[5] as string),
                        chargeTooltip: normalizeServerString(parsed[6] as string),
                        reportNumber: normalizeServerString(parsed[7] as string),
                        arrestNumber: normalizeServerString(parsed[8] as string),
                        caseStatus: normalizeServerString(parsed[9] as string),
                        sequenceNumber: parsed[10] as number,
                        documentTooltip: normalizeServerString(parsed[12] as string),
                        caseTypeId: parsed[13] as number,
                        criminalFlag: parsed[14] as boolean,
                        criminal: parsed[15] as boolean,
                        caseType: normalizeServerString(parsed[16] as string),
                        defendantNumber: parsed[17] as number
                    }
            )
        ));
    }

    public getCaseTemplateList(dsn: string) {

        const url = `${this.baseUrl}WebServices//DefendantInfo.asmx/GetCasePageTemplateList`;
        return this.httpClient.post<string>(url, { dsnSequence: dsn }, { params: { 'showLoader': true } }).pipe(map(wrapper =>
            (<unknown[][]>JSON.parse(wrapper)).map(
                parsed => <CaseTemplatePageType>{
                    caseTypeId: normalizeServerString(parsed[0] as string),
                    standartCaseInfoFlag: parsed[1],
                    template: {
                        name: normalizeServerString(parsed[2] as string),
                        description: normalizeServerString(parsed[3] as string),
                    },
                    configCriminalFlag: parsed[4],
                    CaseTypeName: parsed[5]
                }
            )
        ));
    }

    public createReferralCaseArrestHolding(defendantInfo: DefendantInfoCreate, casePageTypeId: number): Observable<string> {
        const path = '/WebServices/DefendantInfo.asmx/CreateCaseArrestHolding';

        return this.httpClient
            .post<string>(environment.api.url + path, {
                defendantInfo: {
                    DefendantNumber: defendantInfo.defendantNumber,
                    NamePrefix: defendantInfo.namePrefix,
                    FirstName: defendantInfo.firstName,
                    MiddleName: defendantInfo.middleName,
                    LastName: defendantInfo.lastName,
                    NameSuffix: defendantInfo.nameSuffix,
                    Ssn: removeDelimiters(defendantInfo.ssn),
                    Contact: defendantInfo.contact,
                    Phone: removeDelimiters(defendantInfo.phone),
                    Address1: defendantInfo.address1,
                    Address2: defendantInfo.address2,
                    City: defendantInfo.city,
                    State: defendantInfo.state,
                    ZipCode: removeDelimiters(defendantInfo.zipCode),
                    Race: defendantInfo.race,
                    Sex: defendantInfo.sex,
                    Height: removeDelimiters(defendantInfo.height),
                    Weight: defendantInfo.weight,
                    PlaceOfBirth: defendantInfo.placeOfBirth,
                    LocalId: defendantInfo.localId,
                    StateId: defendantInfo.stateId,
                    FederalId: defendantInfo.federalId,
                    DateOfBirth: defendantInfo.dateOfBirth,
                    Hair: defendantInfo.hair,
                    Eyes: defendantInfo.eyes,
                    LicenseState: defendantInfo.licenseState,
                    LicenseNumber: defendantInfo.licenseNumber,
                    LicenseExpirationDate: defendantInfo.licenseExpirationDate,
                    LicenseClass: defendantInfo.licenseClass,
                    InmateNumber: defendantInfo.inmateNumber,
                    DefendantStatus: defendantInfo.defendantStatus,
                    Nationality: defendantInfo.nationality,
                    IsEntity: defendantInfo.isEntity,
                    IsIntl: defendantInfo.isIntl,
                    Agency: defendantInfo.agency,
                    ChildId: defendantInfo.childId,
                    Email: defendantInfo.email,
                },
                casePageTypeId: casePageTypeId,
            }, { params: { 'showLoader': true } })
            .pipe(map(response => response));
    }

    public getOpenReportLink(params: { code: number; sequenceNumber: number, reportNumber: string }): Observable<string> {
        const url = `${this.baseUrl}/WebServices/ReferralHistory.asmx/GetOpenReportLink`;
        return this.httpClient.post<string>(url, { code: params.code, sequenceNumber: params.sequenceNumber, reportNumber: params.reportNumber });
    }

    public reprocessData(reprocessSeqNumbers: string): Observable<void> {
        const url = `${this.baseUrl}/WebServices/ReferralHistory.asmx/ReProcessData`;
        return this.httpClient.post<void>(url, { data: reprocessSeqNumbers }, { params: { 'showLoader': true } });
    }
    
    public isReferralHistoryRecord() {
        const url = `${this.baseUrl}/WebServices/ReferralHistory.asmx/IsReferralHistoryHasRecord`;
        return this.httpClient.post<boolean>(url, {});
    }
    //#endregion

}